import { useCallback, useContext } from "react";

import { useParams } from "react-router-dom";

import { getWardUrl, WARD_TEST_URL, WARDS_ORDER_URL } from "@/core/urls";
import { ViewerContext } from "@/tpo/Viewer";
import { useQuery } from "@apollo/client";

import { REPORTS_LIST_QUERY } from "../reports/graphql/queries";

export default function useWardTestsAndReports() {
  const { userId } = useContext(ViewerContext);
  const { patientId } = useParams();

  const getOrderUrl = useCallback(
    orderId =>
      getWardUrl(WARDS_ORDER_URL, {
        patientId: userId,
        orderId
      }),
    [userId]
  );

  const getTestResultUrl = useCallback(
    userTestId =>
      getWardUrl(WARD_TEST_URL, {
        patientId: userId,
        userTestId
      }),
    [userId]
  );

  const getReportUrl = useCallback(
    report => `/patients/${patientId}/reports/${report.slug}/overview`,
    [patientId]
  );

  const { data: reportsData } = useQuery(REPORTS_LIST_QUERY, {
    variables: {
      userId
    },
    fetchPolicy: "cache-first",
    nextFetchPolicy: "cache-first",
    skip: !userId
  });

  return {
    getOrderUrl,
    getTestResultUrl,
    getReportUrl,
    reports: reportsData?.reports,
    userReports: reportsData?.userReports,
    reportViewType: "customer"
  };
}
